import { render, staticRenderFns } from "./OrdersMapGlobal.vue?vue&type=template&id=0e3117a4"
import script from "./OrdersMapGlobal.vue?vue&type=script&lang=js"
export * from "./OrdersMapGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports